export default "__VITE_ASSET__21e06168__"